import { createContext, useContext, useEffect, useState } from "react";
import { api, setActiveOperator, OPERATOR_STORAGE_KEY } from "./api";

const AuthCtx = createContext(null);

function autoPickOperator(u) {
  // Auto-select if the user has exactly one operator, or clear if none.
  const ids = (u && u.operator_ids) || [];
  const current = localStorage.getItem(OPERATOR_STORAGE_KEY);
  if (ids.length === 1) {
    if (current !== ids[0]) setActiveOperator(ids[0]);
  } else if (ids.length === 0 && u?.role !== "admin") {
    setActiveOperator(null);
  } else if (current && !ids.includes(current) && u?.role !== "admin") {
    setActiveOperator(null);
  }
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("ot_token");
    if (!token) { setUser(false); setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => { setUser(r.data); autoPickOperator(r.data); })
      .catch(() => setUser(false))
      .finally(() => setLoading(false));
  }, []);

  const login = async (identifier, password) => {
    const { data } = await api.post("/auth/login", { identifier, password });
    localStorage.setItem("ot_token", data.token);
    localStorage.setItem("ot_user", JSON.stringify(data.user));
    setUser(data.user);
    autoPickOperator(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("ot_token");
    localStorage.removeItem("ot_user");
    setActiveOperator(null);
    setUser(false);
    window.location.href = "/login";
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
